import { render, staticRenderFns } from "./PhieuTuVan.vue?vue&type=template&id=25603c09&scoped=true"
import script from "./PhieuTuVan.vue?vue&type=script&lang=js"
export * from "./PhieuTuVan.vue?vue&type=script&lang=js"
import style0 from "./PhieuTuVan.vue?vue&type=style&index=0&id=25603c09&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25603c09",
  null
  
)

export default component.exports